"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withKey = exports.renderToStaticMarkup = exports.revertConsole = exports.overrrideConsole = void 0;
const react_1 = __importDefault(require("react"));
const server_1 = __importDefault(require("react-dom/server"));
const ignoreMessagePatterns = [
    /is using incorrect casing\./,
    /React does not recognize/,
    /Invalid DOM property/,
];
const origWarn = global.console.warn;
const filteredWarn = (message, ...args) => {
    if (ignoreMessagePatterns.some(p => p.test(message))) {
        return;
    }
    origWarn(message, ...args);
};
const origError = global.console.error;
const filteredError = (message, ...args) => {
    if (ignoreMessagePatterns.some(p => p.test(message))) {
        return;
    }
    origError(message, ...args);
};
const overrrideConsole = () => {
    console.warn = filteredWarn;
    console.error = filteredError;
    // const origError = global.console.error;
    // console.error = (message, ...args) => {
    //     if (ignoreMessagePatterns.some(p => p.test(message))) {
    //         return;
    //     }
    //     origError(message, ...args);
    // };
    // const origLog = global.console.log;
    // console.log = (message, ...args) => {
    //     if (ignoreMessagePatterns.some(p => p.test(message))) {
    //         return;
    //     }
    //     origLog(message, ...args);
    // };
};
exports.overrrideConsole = overrrideConsole;
const revertConsole = () => {
    console.warn = origWarn;
    console.error = origError;
};
exports.revertConsole = revertConsole;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const renderToStaticMarkup = (element) => {
    try {
        (0, exports.overrrideConsole)();
        const ret = server_1.default.renderToStaticMarkup(element);
        return ret;
    }
    finally {
        (0, exports.revertConsole)();
    }
};
exports.renderToStaticMarkup = renderToStaticMarkup;
const withKey = (els, baseKey = 0) => {
    const ret = [];
    for (let i = 0; i < els.length; i++) {
        const el = els[i];
        if (typeof el === "string") {
            ret.push(el);
        }
        else {
            ret.push(react_1.default.cloneElement(el, { key: baseKey + i }));
        }
    }
    return ret;
};
exports.withKey = withKey;
//# sourceMappingURL=index.js.map